export default "__VITE_ASSET__CUw92klr__"